module.exports = __webpack_public_path__ + "assets/log.76f4a73b.svg";